<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import { tenants } from "@core/config/tenants.js";
	import { Locale } from "@core/schema/Locale.js";
	import { localAliasNameMap } from "@core/schema/names/localAliasNameMap.js";
	import { localeNameMap } from "@core/schema/names/localeNameMap.js";
	import { getHomepagePath } from "@core/schema/paths/getHomepagePath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./MobileMenuLanguageSwitcher.translations.json" with { type: "json" };

	const { tenant, pagePath } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
</script>

<div class="flex sm:hidden full-width text-fcrdarkgray font-medium text-sm/tighter pt-5 pb-6">
	<span class="grow text-fcrgray">
		{translate("language")}
	</span>
	{#each Object.values(Locale) as targetLocale, index (targetLocale)}
		{@const isCurrentLocale = targetLocale === tenant.locale}
		{#if index !== 0}
			<span class="text-fcrgray" aria-hidden>|</span>
		{/if}
		<svelte:element
			this={isCurrentLocale ? "span" : "a"}
			href={isCurrentLocale ? undefined : (pagePath[targetLocale] ?? getHomepagePath(tenants[targetLocale]))}
			title={localeNameMap[tenant.locale][targetLocale]}
			class={[
				isCurrentLocale ? "text-fcrdarkgray font-medium" : "text-fcrgray hover:text-fcrdarkgray",
				"transition-colors px-2",
			]}
		>
			{localAliasNameMap[targetLocale]}
		</svelte:element>
	{/each}
</div>
